import React from 'react'
import { useQuery } from 'react-query'
import { getDetailTransactionsAll } from '../../../../modules/services/transactions.service'
import { convertToRupiah } from '../../../../../_metronic/helpers/currency'


interface Props {
  id? : string
}

const TransactionsInfo: React.FC<Props> = ({id}) => {
  const {data , isLoading} = useQuery(['getTransaction', id], async () => await getDetailTransactionsAll(id))
  const  datas = !isLoading ? data[0] : {}
  const arrayProduct = !isLoading ? datas.attributes?.transaction_details.data : []

  const head = [
    {
      key : 'Date & Time',
      value:  `${datas?.attributes?.TransactionDate}`
    },
    {
      key : 'Transaction ID',
      value:  `${datas?.attributes?.InvoiceNumber}`
    },
    {
      key : 'Total Transaction',
      value:  convertToRupiah(datas?.attributes?.TotalTransaction)
    },
    {
      key : 'Member Name',
      value:  `${datas?.attributes?.Member.data?.attributes?.fullname ?? "-" }`
    },
    {
      key : 'Detail Product',
      value:  `-`
    },
    {
      key : 'Status',
      value:  `${datas?.attributes?.Status}`
    },
  ]
  
  return (
    <div className='row'>
      {
         !isLoading && head.map((e) => (
          <div className='row mb-7'>
              <h4 className='col-lg-4 fw-bold text-muted fs-6'>{e.key}</h4>
              <div className='col-lg-8'>
              { e.key === 'Detail Product'  ?  <>
              <div className='d-flex justify-content-between'>
                <p className='fs-6 ms-8'>{`SKU`}</p>
                <p className='fs-6 ms-8'>{`Product`}</p>
                <p className='fs-6 ms-8'>{`Qty`}</p>
              </div>
              {arrayProduct.map((e: any, i: any) => (
                <div className='d-flex justify-content-between' key={i}>
                  <p className='fs-6 ms-8'>{e.attributes.product.data?.attributes.sku}</p>
                  <p className='fs-6 ms-8'>{e.attributes.product.data?.attributes.name}</p>
                  <p className='fs-6 ms-8'>{e.attributes.Qty}</p>
                </div>
               
              ))}

          </> :   <p className='fs-6 ms-8'>{e.value}</p>}
              </div>
          </div>
        ))
        }
     
     
    </div>
  )
}

export default TransactionsInfo
